import { DbHelper } from "@app/shared/model/db-object.model";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export interface Municipality {
    id: number;
    projectId: number;
    firePhone: number;
    policePhone: number;
    auxiliaryPhone: number;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface MunicipalityData {
    id: number;
    project_id: number;
    fire_phone: number;
    police_phone: number;
    auxiliary_phone: number;
}
/* eslint-enable @typescript-eslint/naming-convention */

export class MunicipalityHelper extends DbHelper<Municipality, MunicipalityData> {
    static readonly dbTypeName = "Municipality";

    static readonly importMap: ImportMap<Municipality, MunicipalityData> = [
        { i: "id", o: "id" },
        { i: "project_id", o: "projectId" },
        { i: "fire_phone", o: "firePhone" },
        { i: "police_phone", o: "policePhone" },
        { i: "auxiliary_phone", o: "auxiliaryPhone" },
    ];

    importMap = MunicipalityHelper.importMap;

    static fromDbObject(data: MunicipalityData): Municipality {
        return ClassImporterExporter.importObject(data, MunicipalityHelper.importMap);
    }

    static toDbObject(obj: Municipality): MunicipalityData {
        return ClassImporterExporter.exportObject(obj, MunicipalityHelper.importMap);
    }

    static isValid(data: Municipality): boolean {
        return !!data;
    }
}
